export const COMMENT_FIELDS = {
  header: {
    qaSpecName: 'Header',
    type: 'Type',
    competitiveProduct: 'Competitive Product',
    sKUType: 'SKU Type',
    competitiveProductUPC: 'Competitive Product UPC',
    competitiveProductBrandRetailPricingTarget:
      'Competitive Product Brand Retail Pricing Target',
    competitiveBrandEquivalencyType: 'Competitive Brand Equivalency Type',
    supplierLocation: 'Supplier Location',
    testingTier: 'Testing Tier',
    retailBanner: 'Retail Banner',
    smartLabelTemplate: 'SmartLabel Template',
    categoryI: 'Category I',
    categoryII: 'CategoryII',
    categoryIII: 'CategoryIII',
    categoryIV: 'CategoryIV',
    differenceAccepted: 'DifferenceAccepted',
  },
  productSpecification: {
    qaSpecName: 'Product Specification',
    qualityGuarantee: 'Quality Guarantee',
    complianceStatement: 'Compliance Statement',
    healthClaims: 'Health Claims',
    glutenFreeClaim: 'Gluten Free Claim',
    structureFunctionClaims: 'Structure / Function Claims',
    relativeComparativeClaims: 'Relative / Comparative Claims',
    safeHandlingInstructions: 'Safe Handling Instructions',
    liveAndActiveCulture: 'Live and Active Culture',
    uSDACanadianGrading: 'USDA / Canadian Grading',
    uSDAShieldID: 'USDA Shield ID',
    uSDAWICEligible: 'USDA WIC Eligible',
    mSDSRequired: 'MSDS Required?',
    certificateBadgeOrOtherCertifications:
      'Certificate Badge or Other Certification',
    eggsGrading: 'Eggs Grading',
    dateCoding: {
      dateCodeOpenClose: 'Date Code Open Closed',
      dateCodeType: 'Date CodeType',
      dateCodeFormula: 'Date Code Formula',
      dateCodeExample: 'Date Code Example',
      batchCodeExample: 'Batch Code Example',
      lotCodeExample: 'Lot Code Example',
    },
    shelfLife: {
      minShelfLifeAtProd: 'Min Shelf Life At Production, In Days',
      maxShelfLifeAtProd: 'Max Shelf Life At Production, In Days',
      shelfLifeAfterOpened: 'Shelf Life After Opening, In Days',
    },
    statement: {
      gMOStatement: 'GMO Statement',
      nonGMOStatement: 'Non-GMO Statement',
      productContainsBioengineeredIngredients:
        'Product Contains Bioengineered Ingredients',
      bioengineeredIngredientsStatement: 'Bioengineered Ingredients Statement',
      rBGH_BSTStatement: 'RBGH/BST Statement',
      californiaProp65WarningStatement: 'California Prop 65 Warning Statement',
      fairTradeStatemente: 'Fair Trade Statement',
      uSDAStatement: 'USDA Statement',
      nonfoodIngredientStatement: 'Nonfood Ingredient Statement',
    },

    locations: {
      targetMarket: 'Target Market',
      countryOfOrigin: 'Country of Origin',
    },

    dietaryCertifications: {
      kosher: 'Kosher',
      certifier: 'Certifier',
      organic: 'Organic',
      halal: 'Halal',
      nonGMO: 'Non-GMO',
      iSO: 'ISO',
      bRC: 'BRC',
      iFS: 'IFS',
    },

    caseTemperatures: {
      caseTemperatureRangeHigh: 'Case Temperature Range High',
      caseTemperatureRangeLow: 'Case Temperature Range Low',
      caseShippingRangeHigh: 'Case Shipping Temperature High',
      caseShippingRangeLow: 'Case Shipping Temperature Low',
    },

    PFAS: {
      productIntentionallyContainPFAS:
        'Does this Product Intentionally Contain PFAS?',
      packagingIntentionallyContainPFAS:
        "Does this Product's Packaging Intentionally Contain PFAS?",
      pFASTestingForThisProduct:
        'Have you conducted any PFAS testing for this product?',
      anyPFASTestingForThisProductPackaging:
        "Have you conducted any PFAS testing for this product's packaging?",
      pFASStatementIfAppropriate: 'PFAS Statement if Appropriate',
      supportingDocumentation: 'Supporting Documentation',
    },

    organolepticCharacteristics: {
      analysisExecuted: 'Analysis Executed',
      parameter: 'Parameter',
      preparationMethod: 'Preparation Method',
      specificationDescriptionTarget: 'Specification Description Target',
      tolerance: 'Tolerance',
      rejectFailCritiria: 'Reject/Fail Critiria',
      frequency: 'Frequency',
      releaseCriteria: 'Release Criteria',
    },

    physicalAndChemicalCharacteristics: {
      analysisExecuted: 'Analysis Executed',
      parameter: 'Parameter',
      method: 'Method',
      valueFoodAndNonFoodProduct: 'Value (Food And Non-Food Product)',
      specificationDescriptionTarget: 'Specification/Description/Target',
      tolerance: 'Tolerance',
      rejectFailCritiria: 'Reject/Fail Critiria',
      refStandard: 'Ref. Standard',
      refMethod: 'Ref. Method',
      testSource: 'Test Source',
      frequency: 'Frequency',
      releaseCriteria: 'Release Criteria',
    },
    contaminantCharacteristics: {
      analysisExecuted: 'Analysis Executed',
      parameter: 'Parameter',
      valueFoodAndNonFoodProduct: 'Value (Food And Non-Food Product)',
      specificationDescriptionTarget: 'Specification/Description/Target',
      tolerance: 'Tolerance',
      rejectFailCritiria: 'Reject/Fail Critiria',
      refStandard: 'Ref. Standard',
      refMethod: 'Ref. Method',
      testSource: 'Test Source',
      frequency: 'Frequency',
      releaseCriteria: 'Release Criteria',
    },
    microbiologicalCharacteristics: {
      analysisExecuted: 'Analysis Executed',
      parameter: 'Parameter',
      method: 'Method',
      valueFoodAndNonFoodProduct: 'Value (Food And Non-Food Product)',
      specificationDescriptionTarget: 'Specification/Description/Target',
      tolerance: 'Tolerance',
      rejectFailCritiria: 'Reject/Fail Critiria',
      refStandard: 'Ref. Standard',
      refMethod: 'Ref. Method',
      testSource: 'Test Source',
      frequency: 'Frequency',
      releaseCriteria: 'Release Criteria',
    },
    document: {
      documentName: 'Document Name',
      charactersticsType: 'Characterstics Type',
      fileType: 'File Type',
      fileSize: 'File Size',
      uploadDate: 'Upload Date',
    },
  },
  petFood: {
    qaSpecName: 'Pet Food',
  },
  documentAndCertificate: {
    qaSpecName: 'Documents/ Certificate',
  },
  documentAndCertificateFinalArt: {
    qaSpecName: 'Documents/ Certificate - Final Art',
  },
   qaSpecTemplateDocuments: {
    qaSpecName: 'QA Spec Template Documents',
  },
};
